import React from 'react';
import SkeletonCardHeader from './SkeletonCard.Headery';
import SkeletonCardBody from './SkeletonCard.Body';

interface SkeletonCardProps {
  height?: number;
  width?: number;
}

const SkeletonCard: React.FC<SkeletonCardProps> = ({
  height,
  width,
}: SkeletonCardProps) => {
  return (
    <div>
      <div style={{ paddingBottom: 5 }}>
        <SkeletonCardHeader width={width} />
      </div>
      <div style={{ paddingBottom: 8 }}>
        <SkeletonCardBody height={height} width={width} />
      </div>
    </div>
  );
};

export default SkeletonCard;
